import React from "react";
import { motion } from "framer-motion";
import "./WhatWeDo.css";
import { FaLightbulb, FaBullseye, FaPalette, FaRocket, FaHandshake, FaCogs } from "react-icons/fa";

function KeyFeatures() {
  return (
    <section className="key-features">
      <h2 id="key">Why Choose Us?</h2>
      <div className="services-grid">
        {[
          { icon: <FaLightbulb />, title: "Innovative Solutions", text: "We craft creative and forward-thinking strategies tailored to your business needs." },
          { icon: <FaBullseye />, title: "Result-Oriented", text: "Our focus is on delivering measurable success and tangible outcomes for your brand." },
          { icon: <FaPalette />, title: "Creative Excellence", text: "Our team specializes in visually stunning and impactful designs to enhance your brand identity." },
          { icon: <FaRocket />, title: "Fast & Efficient", text: "We ensure rapid execution of strategies while maintaining high-quality standards." },
          { icon: <FaHandshake />, title: "Client-Centered", text: "We build strong relationships through collaboration, transparency, and personalized service." },
          { icon: <FaCogs />, title: "Technical Mastery", text: "From development to automation, we leverage the latest technologies to power your success." }
        ].map((feature, index) => (
          <motion.div 
            className="service-item"
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <span className="icon">{feature.icon}</span>
            <h3>{feature.title}</h3>
            <p>{feature.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default KeyFeatures;
